import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './AdvancedSearch.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import * as Components from './components/index';
import * as functions from '../../helper/functions';
import * as propertyActions from "../../redux/action/property.action";
import * as generalActions from "../../redux/action/general.action";

class AdvancedSearch extends React.Component {
  async componentDidMount() {
    await this.setSelectedFilter();
    this.initialize(true);

    this.props.setFilterBar(window.innerWidth > 768);
  }

  componentWillUnmount() {
    this.props.setFilterBar(false);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const {filter: preFilter, location: preLocation} = this.props;
    const {filter: nextFilter, location: nextLocation} = nextProps;

    // When filter state changed this section put the filter section on url
    if (JSON.stringify(preFilter) !== JSON.stringify(nextFilter)) {
      const query = functions.objectToQueryParameter(nextFilter);
      this.props.history.push(`?${query}`);
    }

    // When query string changed this section fetch list data based on new filter
    if (preLocation.search !== nextLocation.search) {
      this.fetchProperties();
    }

    // When selected item changed this section call initialize data again to retrieve newly selected item
    if (preLocation.pathname !== nextLocation.pathname) {
      this.initialize(false, preLocation.pathname);
    }

    return true;
  }

  initialize = async (canFetch) => {
    const {fetchProperty, fetchProperties, setSelectedProperty} = this.props;
    try {
      canFetch && await fetchProperties();

      const paths = functions.getFilterName();
      if (paths.length === 2) {
        await fetchProperty(paths[1]);
      } else {
        setSelectedProperty();
      }
    } catch (e) {
    }
  };

  async setSelectedFilter() {
    const qs = functions.parseQuery(this.props.history.location.search);
    qs.from = qs.from || 0;
    qs.length = qs.length || 15;
    await this.props.setFilter(qs);
  }

  fetchProperties = async () => {
    const {fetchProperties} = this.props;
    try {
      await fetchProperties();
    } catch (e) {
    }
  };

  render() {
    const { selectedProperty } = this.props;
    const justMap = this.props.location.search.indexOf('map');
    const justList = this.props.location.search.indexOf('list');
    return (
      <React.Fragment>
        <Container fluid className={`pl-4 pr-4 text-right sticky-top ${style.filter_bar}`}>
          <Components.FilterBar />
        </Container>
        <Container fluid className={`p-0`}>
          <Row className={'m-0'}>
            {
              justMap > 0 ? (
                <Col xs={12} className={`m-0 p-0`}>
                  <Components.PropertiesOnMap />
                  {
                    selectedProperty && (
                      <Components.Detail />
                    )
                  }
                </Col>
              ) : justList > 0 ? (
                <Col xs={12}>
                  <Components.Properties />
                  <Components.Pagination />
                </Col>
              ) : (
                <>
                  <Col xs={12} md={"6"} lg={"7"} className={`d-none d-md-block m-0 p-0`}>
                    <Components.PropertiesOnMap />
                    {
                      selectedProperty && (
                        <Components.Detail />
                      )
                    }
                  </Col>
                  <Col xs={12} md={"6"} lg={"5"}>
                    <Components.Properties />
                    <Components.Pagination />
                  </Col>
                </>
              )
            }
          </Row>
        </Container>
        {
          selectedProperty && (
              <div className={style.detail_container}>
                <Components.Detail />
              </div>
          )
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.property.filter,
  selectedProperty: state.property.selectedProperty
});

const mapDispatchToProps = (dispatch) => ({
  setFilterBar: (show) => dispatch(generalActions.setFilterBar(show)),
  fetchProperties: (loading ) => dispatch(propertyActions.fetchProperties(loading)),
  fetchProperty: (id, loading) => dispatch(propertyActions.fetchProperty(id, loading)),
  setSelectedProperty: (property) => dispatch(propertyActions.setSelectedProperty(property)),
  setFilter: (filter) => dispatch(propertyActions.setFilter(filter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdvancedSearch));
